import request from '@/utils/request'

export function getSafetyManageDoc(param, isNotify) {
  return request({
    url: `/api/getSafetyManageDoc`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
}

export function saveSafetyManageDoc(param, isNotify) {
  return request({
    url: `/api/saveSafetyManageDoc`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'saved' },
  })
}

export function deleteSafetyManageDoc(param, isNotify) {
  return request({
    url: `/api/deleteSafetyManageDoc`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'deleted' },
  })
}